import { Outlet } from "react-router-dom";
import { SideBar, Header } from "@/components";

export default function DashboardLayout() {
  return (
    <div className="flex h-screen">
      <SideBar />
      <div className="flex-1 flex flex-col">
        <Header />
        <div className="flex-1 overflow-auto bg-[#f8f8f8]">
          <div className="w-full flex justify-center mx-auto bg-[#f8f8f8]">
            <div className="w-full md:max-w-6xl">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
